import { render, staticRenderFns } from "./ProfessionalGroupForm.vue?vue&type=template&id=056006f5&"
import script from "./ProfessionalGroupForm.vue?vue&type=script&lang=js&"
export * from "./ProfessionalGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports